import { render } from "./rub_egp.vue?vue&type=template&id=d7b55272"
import script from "./rub_egp.vue?vue&type=script&lang=js"
export * from "./rub_egp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__